// extracted by mini-css-extract-plugin
export default {"root":"PurchaseAdviceDialog_root__upb3G"};